import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

class ProductSort extends React.Component {
  static defaultProps = {
    sorting: {
      compatioscore_descending: {
        label: 'Recommended',
        sortDirection: 'ascending',
        productKey: 'compatioScore',
      },
      price_ascending: {
        label: 'Price (low to high)',
        sortDirection: 'ascending',
        productKey: 'price',
      },
      price_descending: {
        label: 'Price (high to low)',
        sortDirection: 'descending',
        productKey: 'price',
      },
      alphabetical_ascending: {
        label: 'Alphabetical (A > Z)',
        sortDirection: 'ascending',
        productKey: 'name',
      },
      alphabetical_descending: {
        label: 'Alphabetical (Z > A)',
        sortDirection: 'descending',
        productKey: 'name',
      },
    },
  };
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    const sortOrder = event.target.value;
    this.props.handleChangeSortOrder(sortOrder);
  }

  handleClick = () => {
    var x = document.getElementById('left-bar');

    // console.log(x);
    if (x.style.display === 'none') {
      x.style.display = 'block';
      x.style.transition = 'all 2s ease-in-out';
    } else if (x.style.display == '') {
      x.style.display = 'block';
      x.style.transition = 'all 2s ease-in-out';
    } else {
      x.style.display = 'none';
      x.style.transition = 'all 2s ease-in-out';
    }
  };

  render() {
    const sorting = this.props.sorting;
    let optionList = [];
    Object.keys(sorting).forEach(key => {
      const labelText = this.props.intl.formatMessage({
        id: `ProductSort.sorting.${key}`,
        defaultMessage: sorting[key].label,
      });
      optionList.push(
        <option key={key} value={key}>
          {labelText}
        </option>
      );
    });

    return (
      <div className="xrs-products__sort">
        <div
          className={
            this.props.appliedFilters !== null &&
            this.props.appliedFilters.length > 0
              ? this.props.appliedFilters.length === 1
                ? `dcs-filter active`
                : `dcs-filter active`
              : `dcs-filter`
          }
          onClick={this.handleClick}
        >
          <svg
            fill="none"
            height="24"
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            viewBox="0 0 24 24"
            width="24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
          </svg>
          <span>
            {this.props.appliedFilters !== null &&
            this.props.appliedFilters.length > 0
              ? this.props.appliedFilters.length === 1
                ? `${this.props.appliedFilters.length} Attribute`
                : `${this.props.appliedFilters.length} Attributes`
              : `Filter`}
          </span>
        </div>

        <label>
          <FormattedMessage
            id="ProductSort.sort_by_label"
            defaultMessage="Sort by :"
          />
          <select
            value={this.props.currentSortOrder}
            onChange={this.handleChange}
            data-testid="product_sort_select"
          >
            {optionList}
          </select>
        </label>
      </div>
    );
  }
}

export default injectIntl(ProductSort);
